import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const AdvisorIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M14.5449 4.88623L10.401 9.03017C10.3483 9.08295 10.2857 9.12481 10.2168 9.15338C10.1479 9.18195 10.0741 9.19665 9.99947 9.19665C9.92488 9.19665 9.85103 9.18195 9.78214 9.15338C9.71324 9.12481 9.65065 9.08295 9.59795 9.03017L8.29492 7.72714"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.48187 10.8726L1.47656 14.5453L4.31747 15.1135L5.45384 18.5226L8.47656 13.7256"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5181 10.8726L18.5234 14.5453L15.6825 15.1135L14.5462 18.5226L11.5234 13.7256"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6822 8.13418L16.3216 9.81297C16.3679 9.93408 16.3714 10.0674 16.3315 10.1908C16.2915 10.3142 16.2105 10.4201 16.1019 10.491L14.5973 11.4759L14.1276 13.2107C14.0937 13.3358 14.0181 13.4456 13.9132 13.5218C13.8084 13.598 13.6806 13.636 13.5511 13.6296L11.7564 13.5402L10.3572 14.6675C10.256 14.7488 10.1301 14.7931 10.0004 14.7931C9.87058 14.7931 9.7447 14.7488 9.64354 14.6675L8.24429 13.538L6.4496 13.6274C6.32013 13.6338 6.19236 13.5957 6.08749 13.5195C5.98263 13.4433 5.90697 13.3335 5.87308 13.2084L5.40338 11.4736L3.89884 10.4887C3.79025 10.4178 3.70923 10.3119 3.66925 10.1885C3.62928 10.0651 3.63277 9.93181 3.67914 9.8107L4.31854 8.13418L3.67914 6.45464C3.63193 6.33304 3.628 6.1989 3.66801 6.07475C3.70801 5.95059 3.78952 5.84398 3.89884 5.77282L5.40338 4.78797L5.87308 3.05312C5.90697 2.928 5.98263 2.81823 6.08749 2.74203C6.19236 2.66583 6.32013 2.62777 6.4496 2.63418L8.24429 2.72737L9.64354 1.60312C9.7447 1.52184 9.87058 1.47754 10.0004 1.47754C10.1301 1.47754 10.256 1.52184 10.3572 1.60312L11.7564 2.72737"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
